<template>
  <div class="sub_container">
    <section class="sub_visual">
      <h2 class="vi_tit">팝업 테스트 페이지</h2>
    </section>

    <section class="sub_contents">
      <h1>팝업 테스트 페이지</h1>
      <div class="sub_contents_wrap">

alert, confirm, dialog 등등..

        <br/>
        <br/>        

<button type="button" @click="Alert">alert창</button>

        <br/>
        <br/>        

<button type="button" @click="Confirm">confirm창</button>

        <br/>
        <br/>        

<button type="button" @click="Dialog">dialog</button> 다이얼로그에 전달/수신 데이터 : {{popParam}}

        <br/>

        <ul>
            <li>
                <a href="/#/home">홈으로..</a>
            </li>
        </ul>

        <br/>
        <br/>
        <br/>
        <br/>

        <a href="javascript:void(0);" class="button white" @click="slide"><span>슬라이드 다이얼로그??</span></a>

        <br/>
        <br/>
        <br/>
        <br/>

        <a href="javascript:void(0);" class="button white" @click="popAmPartList"><span>호환상품보기</span></a>

        <br/>
        <br/>
        <br/>
        <br/>

        <a href="javascript:void(0);" class="button white" @click="openSknProductSrchPop"><span>SKN 상품조회</span></a>
        전달인자 : [선택상품코드 : (MABANOL(마바눌) 5W32 (productId : {{chosenProductCode}})), 선택보험사번호 : 4, 대리점번호 : 1]
        <br/>
        호환상품코드 : MABANOL(마바눌) 5W30 (productId : SKNAD5W30LL) -> MABANOL(마바눌) 5W34 (productId : SKNAD5W34LL)

        <br/>
        <br/>
        <br/>
        <br/>

        <a href="javascript:void(0);" class="button white" @click="openInsuranceChargerPopup"><span>보험담당자조회</span></a>
        선택보험사 : 테스트 보험사 (insuranceNo : {{insuranceCompanyCode}})

        <br/>
        <br/>
        <br/>
        <br/>

        <a href="javascript:void(0);" class="button white" @click="openBrandCarNamePopup"><span>브랜드/차량명 조회</span></a>
        <br/>
        <br/>
        <br/>
        <br/>

        <a href="javascript:void(0);" class="button white" @click="openCarModelViewPopup"><span>차량이미지 보기</span></a>
        <br/>
        <br/>
        <br/>
        <br/>

        <a href="javascript:void(0);" class="button white" @click="openTempStorageSrchPopup"><span>임시저장조회(일반)</span></a>
        <br/>
        <br/>
        <br/>
        <br/>

        <a href="javascript:void(0);" class="button white" @click="openTempStorageInsrncSrchPopup"><span>임시저장조회(보험)</span></a>
        <br/>
        <br/>
        <br/>
        <br/>

        <a href="javascript:void(0);" class="button white" @click="partsCodeSearch"><span>상품코드조회</span></a>
        <br/>
        <br/>
        <br/>
        <br/>   

        <a href="javascript:void(0);" class="button white" @click="clientSearch"><span>거래처조회</span></a>
        <br/>
        <br/>
        <br/>
        <br/>  

        <a href="javascript:void(0);" class="button white" @click="carModelNameSearch"><span>차량모델조회</span></a>
        <br/>
        <br/>
        <br/>
        <br/>  

        <a href="javascript:void(0);" class="button white" @click="openInsurancePriceSrchPopup"><span>보험가격조회</span></a>
        <br/>
        <br/>
        <br/>
        <br/>  

        <a href="javascript:void(0);" class="button white" @click="openRepairShopSrchPopup"><span>수리공장찾기</span></a>
        <br/>
        <br/>
        <br/>
        <br/>      

        <a href="javascript:void(0);" class="button white" @click="openProductDetailPopup"><span>상품상세조회</span></a>
      </div>
    </section>

        <testSlidePopup ref="testSlide" v-on:test-slide-complete="slideComplete" />

        <testPopup v-model="popParam" />

        <SknProductSrchPop ref="sknProductSrchPop" v-model="chosenProductCode" v-on:test-slide-complete="slideComplete" />

        <insuranceChargerPopup v-model="insuranceCompanyCode" v-on:insuranceChargerPopup="selectInsuranceCharger"/>

        <brandCarNamePopup v-on:brandCarNamePopup="selectBrandCarNamePopup"/>

        <carModelViewPopup v-model="carCode"/>

        <tempStoragePopup v-on:temp-storage-srch-popup-complete="tempStorageSrchPopupComplete" v-model="tempStorageParam" />

        <tempStorageInsrncPopup v-on:temp-storage-insrnc-srch-popup-complete="tempStorageInsrncSrchPopupComplete" v-model="tempStorageInsrncParam" />

        <partsCodeSearchSlidePopup ref="partsCodeSearchSlide" v-on:parts-code-search-slide-complete="partsCodeSearchSlideComplete" v-model="partsCodeParam"/>

        <clientSrchPopup v-on:client-srch-popup-complete="clientSrchPopupComplete" v-model="clientParam"/>

        <carModelNameSrchPopup v-on:car-model-name-srch-popup-complete="carModelNameSrchPopupComplete" v-model="carModelNameParam"/>

        <insurancePriceSrchPopup v-on:insrnc-price-srch-popup-complete="insurancePriceSrchPopupComplete" v-model="insrncPriceParam"/>

        <repairShopSrchPopup v-on:repair-shop-srch-popup-complete="repairShopSrchPopupComplete" v-model="repairShopParam"/>

        <productDetailPopup v-on:product-detail-popup-complete="productDetailPopupComplete" v-model="productDetailParam"/>
    </div>
</template>

<script>
import Vue from 'vue'
import TestPopup from './TestPopup.vue'
import TestSlidePopup from './TestSlidePopup.vue'
import ProductDetailPopup from '../common/ProductDetailPopup.vue'
import SknProductSrchPop from '../common/SknProductSrchPopup.vue'
import InsuranceChargerPopup from '../common/InsuranceChargerPopup.vue'
import BrandCarNamePopup from '../common/BrandCarNamePopup.vue'
import CarModelViewPopup from '../common/CarModelViewPopup.vue'
import TempStoragePopup from '../common/TempStoragePopup.vue'
import TempStorageInsrncPopup from '../common/TempStorageInsrncPopup.vue'
import PartsCodeSearchSlidePopup from '../common/partsCodeSearch/PartsCodeSearchSlidePopup.vue'
import ClientSrchPopup from '../common/ClientSrchPopup.vue'
import CarModelNameSrchPopup from '../common/CarModelNameSrchPopup.vue'
import InsurancePriceSrchPopup from '../common/InsurancePriceSrchPopup.vue'
import RepairShopSrchPopup from '../common/RepairShopSrchPopup.vue'

export default {
  name: 'pop_test',
  components: { TestPopup, TestSlidePopup, ProductDetailPopup, 
                SknProductSrchPop, InsuranceChargerPopup, BrandCarNamePopup,
                CarModelViewPopup, TempStoragePopup, PartsCodeSearchSlidePopup, 
                ClientSrchPopup, CarModelNameSrchPopup, InsurancePriceSrchPopup,
                RepairShopSrchPopup, TempStorageInsrncPopup },
  data () {
    return {
      popParam:'test',
      insuranceCompanyCode: '4', // 보험담당자조회 보험사 코드
      carCode: 'vhtp00001', // 브랜드/차량명 조회 차량 코드
      chosenProductCode: 'SKNAD5W32LL', // SKN상품조회 선택 상품
      tempStorageParam: '',
      tempStorageInsrncParam: '',
      partsCodeParam: '',
      clientParam: '',
      carModelNameParam: '',
      insrncPriceParam: '',
      repairShopParam: '',
      productDetailParam: ''
      
    }
  },
  methods : {
    Alert () {
      Vue.Alert.alert('Alert test!!!').then(() => { alert('11111'); });
    },
    Confirm () {
      Vue.Alert.confirm('Confirm test!!!')
               .then(result => {
                  if (result) {
                    alert('확인');
                  } else {
                    alert('취소');
                  }
                });      
    },
    Dialog () {
      this.$modal.show('testPopup');
    },
    slide () {
      this.$refs.testSlide.open()
    },
    slideComplete () {
     Vue.Alert.alert('완료!!'); 
    },
    popPartDetail () {
      this.$modal.show('partDetailPopup', {});
    },
    popAmPartList () {
      this.$modal.show('amPartListPopup', {});
    },
    insertAmPart (data) {
      alert(data)
    },
    openSknProductSrchPop () {
      var val = 'SKNAD5W32LL';
      this.chosenProductCode = val;
      // 또는 $('#billing-card-grid').alopexGrid('dataGet', {_state: {edited:true}}, {_state:{selected:true}});
      // 그리드에서 선택된 로우 전체
      // 전달 인자 : 상품코드, 보험사번호, 대리점번호
      this.$refs.sknProductSrchPop.open([this.chosenProductCode, 4, 1]);
    },
    slideComplete (data) {
        Vue.Alert.alert(data);
    },
    openInsuranceChargerPopup () {
      this.$modal.show('insuranceChargerPopup', {});
    },
    selectInsuranceCharger (data) {
        Vue.Alert.alert(data);
    },
    openBrandCarNamePopup () {
      this.$modal.show('brandCarNamePopup', {});
    },
    selectBrandCarNamePopup (data) {
      alert(data);
    },
    openCarModelViewPopup() {
      this.$modal.show('carModelViewPopup', {});
    },
    openTempStorageSrchPopup () {
      this.$modal.show('tempStoragePopup', {});
    },
    tempStorageSrchPopupComplete (data) {
      Vue.Alert.alert(data);
    },
    openTempStorageInsrncSrchPopup () {
      this.$modal.show('tempStorageInsrncPopup', {});
    },
    tempStorageInsrncSrchPopupComplete (data) {
      Vue.Alert.alert(data);
    },
    partsCodeSearch () {
      this.$refs.partsCodeSearchSlide.open(this.partsCodeParam);
    },
    partsCodeSearchSlideComplete(data) {
      Vue.Alert.alert(data); 
    },
    clientSrchPopupComplete(data) {
      Vue.Alert.alert(data); 
    },
    clientSearch() {
      this.$modal.show('clientSrchPopup', {});
    },
    carModelNameSrchPopupComplete(data) {
      Vue.Alert.alert(data); 
    },
    carModelNameSearch() {
      this.$modal.show('carModelNameSrchPopup', {});
    },
    openInsurancePriceSrchPopup() {
      this.$modal.show('insurancePriceSrchPopup', {});
    },
    insurancePriceSrchPopupComplete(data) {
      Vue.Alert.alert(data); 
    },
    openRepairShopSrchPopup() {
      this.$modal.show('repairShopSrchPopup', {});
    },
    repairShopSrchPopupComplete(data) {
      Vue.Alert.alert(data); 
    },
    openProductDetailPopup() {
      this.$modal.show('productDetailPopup', {});
    },
    productDetailPopupComplete(data) {
      Vue.Alert.alert(data); 
    }
  }
}
</script>


// WEBPACK FOOTER //
// src/views/test/PopTest.vue